import styled from 'styled-components';

import levelBadgeImg from '../../assets/level-badge.png';

export const BoxContainer = styled.div`
  position: relative;
  display: flex;
  padding: 1.5rem;
  width: 100%;
  background: ${props => props.theme.cards.primary};
  border: 1px solid ${props => props.theme.cards.border};
  box-shadow: ${props => props.theme.shadows.primary};
  border-radius: ${props => props.theme.radius.primary};
`;

export const LevelProgressBadge = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  margin-right: 28px;
  width: 88px;
  height: 86px;
  background: url(${levelBadgeImg}) no-repeat 50%;

  /* TABLET */
  @media (max-width: 768px) {

  }
  /* MOBILE */
  @media (max-width: 480px) {

  }
`;

export const LevelProgressTitle = styled.p`
  font-size: .6875rem;
  font-weight: 700;
  text-transform: uppercase;
  text-align: center;
  color: #ffffff;
  margin-top: -5px;
`;

export const LevelProgressNumber = styled.p`
  font-size: 1.6rem;
  font-weight: 700;
  text-align: center;
  color: #ffffff;
  line-height: 1;
  margin-top: 0;
`;

export const ProgressStat = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  flex-direction: row;
`;

export const BarProgressInfo = styled.p`
  justify-content: flex-start;
  font-weight: 700;
  display: flex;
  align-items: center;
  width: 50%;
  flex-direction: column;
  align-items: flex-start;
  color: ${props => props.theme.colors.textColor};

  > span:nth-child(1) {
    font-size: 1.75rem;
    font-weight: 700;
    line-height: 1;
  }
  > span:nth-child(2) {
    font-size: 11px;
    font-weight: 500;
    text-transform: none;
    line-height: 1;
    margin-top: 10px;
    color: ${props => props.theme.colors.muted};
  }

  /* TABLET */
  @media (max-width: 768px) {
    width: 100%;
    > span:nth-child(1) {
      font-size: 1rem;
    }
  }
  /* MOBILE */
  @media (max-width: 480px) {

  }
`;

export const ProgressBarContent = styled.div`
  width: 100%;
  flex-direction: column;
  margin-top: 1rem;
`;

export const ProgressStatInfo = styled.p`
  color: ${props => props.theme.colors.white};
  font-size: 1.75rem;
  font-weight: 700;
  text-transform: uppercase;
  text-align: right;
  justify-content: flex-end;

  > span {
    font-size: 11px;
    display: flex;
    align-items: right;
    font-weight: 500;
    color: ${props => props.theme.colors.muted};
  }

  /* TABLET */
  @media (max-width: 768px) {
    display: none;
  }
  /* MOBILE */
  @media (max-width: 480px) {
  }
`;

export const Break = styled.div`
  flex-basis: 100%;
  height: 0;
  width: 100%;
`;
